import AbstractShape from "@/Models/Shapes/AbstractShape";
import { InterfaceModelDecorator, ShapeModelDecorator } from "./PreviewModelDecorator";
import { IModel } from "makerjs";
import DimensionLine from "@/Models/Lines/DimensionLine";
import { makerjs } from "../../../../source/js/shared/rendering/makerjs";
import OffsetLine from "@/Models/Lines/OffsetLine";
import GuideLine from "@/Models/Lines/GuideLine";
import Cutout from "@/Models/Cutout";
import { getShapeModelCenter } from "@/functions/makerjs";

export default class DimensionLineDecorator implements InterfaceModelDecorator {
	constructor(
		private parentDecorator: InterfaceModelDecorator | null,
		private baseShapeInstance: AbstractShape,
		private ratio = 1,
		private focusedElement?: string,
		private forceRender: boolean = false
	) {}

	getModel(): IModel {
		let model = { models: {} } as IModel;

		if (this.parentDecorator) {
			model = this.parentDecorator.getModel();
		}

		const dimensionLines = this.baseShapeInstance.getDimensionLines(this.ratio, this.focusedElement, this.forceRender);

		dimensionLines.forEach((dimensionLine: DimensionLine, index: number) => {
			const dimensionLineModel = dimensionLine.getModel();
			dimensionLineModel.layer = "dimension-lines";
			makerjs.model.addModel(model.models.shapeModel, dimensionLineModel, `dimensionLine_${index}`);
		});

		return model;
	}
}

export class OffsetLineDecorator implements InterfaceModelDecorator {
	constructor(
		private parentDecorator: InterfaceModelDecorator | null,
		private baseShapeInstance: AbstractShape,
		private cutout: Cutout,
		private focusedElement: string
	) {}

	getModel(): IModel {
		let model = { models: {} } as IModel;

		if (this.parentDecorator) {
			model = this.parentDecorator.getModel();
		}

		const originalModel = this.cutout.instance;
		const originalModelDecorator = new ShapeModelDecorator(null, originalModel).getModel();
		const center = getShapeModelCenter(originalModelDecorator.models.shapeModel.models.baseModel);
		const offsetLines = this.baseShapeInstance.getOffsetLines(this.cutout.offsets, center, this.focusedElement);

		offsetLines.forEach((offsetLine: OffsetLine, index: number) => {
			const offsetLineModel = offsetLine.getModel();
			offsetLineModel.layer = "offset-lines";
			makerjs.model.addModel(model.models.shapeModel, offsetLineModel, `offsetLine_${index}`);
		});

		return model;
	}
}

export class GuideLineDecorator implements InterfaceModelDecorator {
	constructor(
		private parentDecorator: InterfaceModelDecorator | null,
		private baseShapeInstance: AbstractShape,
		private focusedElement: string
	) {}

	getModel(): IModel {
		let model = { models: {} } as IModel;

		if (this.parentDecorator) {
			model = this.parentDecorator.getModel();
		}

		const guideLines = this.baseShapeInstance.getGuideLines(this.focusedElement);

		guideLines.forEach((guideLine: GuideLine, index: number) => {
			const guideLineModel = guideLine.getModel();
			guideLineModel.layer = "guide-lines";
			makerjs.model.addModel(model.models.shapeModel, guideLineModel, `guideLine_${index}`);
		});

		return model;
	}
}
